import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    props: { comp: 'Home' },
    component: () => import('../views/Bases/BasePrivate.vue')
  },
  {
    path: '/validations',
    name: 'Validations',
    props: { comp: 'Validations' },
    component: () => import('../views/Bases/BasePrivate.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
